export default __webpack_public_path__ + "static/media/logo.816bc691.svg";